import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import {Checkbox} from "@irati/ui/src/FormItem"
import HintText from "@irati/ui/src/HintText"
import id from "@irati/utils/id"

export const PROPERTY = "preferences.includeActionBoard"

/**
 * Get the checkbox value
 *
 * @param schedule
 * @returns {boolean}
 * @private
 */
const _getPropertyValue = (schedule) => !!get(schedule, PROPERTY, false) || false

const IncludeActionBoard = ({schedule, onChange, className, hint, ...props}) => {
  const idNamespace = id("IncludeActionBoard", props)
  return (
    <div className={className}>
      <Checkbox
        {...props}
        id={idNamespace}
        name={PROPERTY}
        onChange={() => onChange(schedule, PROPERTY, !_getPropertyValue(schedule))}
        checked={_getPropertyValue(schedule)}>
        Include link to the action board?
      </Checkbox>
      <HintText id={id("copy-hint", idNamespace)} small>
        {hint}
      </HintText>
    </div>
  )
}

IncludeActionBoard.propTypes = {
  schedule: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  hint: PropTypes.string,
  className: PropTypes.string
}

IncludeActionBoard.defaultProps = {
  hint: `
  This will mean the action board is available at the end of every survey, so you can demonstrate the impact of
  everyone's feedback`,
  className: null
}

export default IncludeActionBoard
